import React from "react";
import { FormattedMessage } from "react-intl";

import { FormatDate } from "~/components/common/FormatDate";

export function PatientPlanExpectedDate({ date }: { date: string | null }) {
  if (!date) return null;

  return (
    <div className="tw-mb-4 tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-2 tw-gap-y-1 tw-text-sm" data-testid="patient-plan-expected-date">
      <span className="tw-text-muted-foreground">
        <FormattedMessage id="pat.block.right.plan_date" />
      </span>
      <strong className="tw-font-medium">
        <FormatDate value={date} date />
      </strong>
    </div>
  );
}
